module.exports = __webpack_public_path__ + "4580e7100daa41b174f9b9e296bd10b7.jpg";